module.exports = __webpack_public_path__ + "img/pijltje-rechts-donker.d5e2de9dd0b4ab4fa3a3d48fbf45be9b.svg";